import styled from 'styled-components'

export const PageMainWrapper = styled.main`
  max-width: 68rem;
  margin: auto;
`
